import { Button } from "@/components"
import React from "react"

export interface ButtonViewProfileProps {
    contact?: number
}

const ButtonViewProfile = ({ contact }: ButtonViewProfileProps) => {
    const contactPagePath = `/contact/${contact}/`

    const openWindow = () => {
        const width = 1200
        const height = 800
        const left = (window.screen.width - width) / 2 // centered
        const top = (window.screen.height - height) / 2 // centered

        window.open(contactPagePath, "_blank", `width=${width},height=${height},left=${left},top=${top}`)
    }

    return (
        <Button variant="outline" disabled={!contact} onClick={() => openWindow()} data-cy="button-view-profile">
            View contact
        </Button>
    )
}

export default ButtonViewProfile
